import { setProperties } from "./setProperties.js";
import { getTplStateStore } from "../CustomTemplates/utils.js";
import { getFormStateStore } from "../FormRenderer/utils.js";
export function listenOnTrackingContext(brick, trackingContextList) {
  for (const track of trackingContextList) {
    var _brick$disposes;
    const listener = () => {
      if (brick.element) {
        setProperties(brick.element, {
          [track.propName]: track.propValue
        }, brick.runtimeContext);
      }
    };
    (_brick$disposes = brick.disposes) !== null && _brick$disposes !== void 0 ? _brick$disposes : brick.disposes = [];
    if (track.contextNames) {
      for (const contextName of track.contextNames) {
        brick.disposes.push(brick.runtimeContext.ctxStore.onChange(contextName, listener));
      }
    }
    if (track.stateNames) {
      const tplStateStore = getTplStateStore(brick.runtimeContext, "STATE", `: "${track.propValue}"`);
      for (const stateName of track.stateNames) {
        brick.disposes.push(tplStateStore.onChange(stateName, listener));
      }
    }
    if (track.formStateNames) {
      const formStateStore = getFormStateStore(brick.runtimeContext, "FORM_STATE", `: "${track.propValue}"`);
      for (const stateName of track.formStateNames) {
        brick.disposes.push(formStateStore.onChange(stateName, listener));
      }
    }
  }
}
export function trackAfterInitial(runtimeContext, trackingContextList, initialTracker) {
  if (!initialTracker) {
    return;
  }
  for (const {
    contextNames,
    stateNames,
    propValue
  } of trackingContextList) {
    if (contextNames) {
      for (const contextName of contextNames) {
        initialTracker.disposes.push(runtimeContext.ctxStore.onChange(contextName, initialTracker.listener));
      }
    }
    if (stateNames) {
      for (const stateName of stateNames) {
        const tplStateStore = getTplStateStore(runtimeContext, "STATE", `: "${propValue}"`);
        initialTracker.disposes.push(tplStateStore.onChange(stateName, initialTracker.listener));
      }
    }
  }
}
//# sourceMappingURL=listenOnTrackingContext.js.map